"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = exports.CheckboxTheme = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var checkbox_1 = require("wix-ui-core/checkbox");
var CheckboxChecked_1 = require("wix-ui-icons-common/system/CheckboxChecked");
var CheckboxIndeterminate_1 = require("wix-ui-icons-common/system/CheckboxIndeterminate");
var dataHooks_1 = require("./dataHooks");
var Checkbox_st_css_1 = require("./Checkbox.st.css");
var IconTooltip_1 = require("../IconTooltip");
var Error_1 = require("wix-ui-icons-common/on-stage/Error");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var uniqueId = require('lodash/uniqueId');
var CheckboxTheme;
(function (CheckboxTheme) {
    CheckboxTheme["Default"] = "default";
    CheckboxTheme["Box"] = "box";
})(CheckboxTheme = exports.CheckboxTheme || (exports.CheckboxTheme = {}));
/** An implementation of Checkbox for TPAs */
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this._rootRef = React.createRef();
        _this.state = {
            focused: false,
            isErrorTooltipShown: false,
        };
        _this._renderIcon = function (isFocused) {
            var _a;
            var _b = _this.props, checked = _b.checked, indeterminate = _b.indeterminate, error = _b.error;
            return (React.createElement("span", { className: classnames_1.default(Checkbox_st_css_1.classes.icon, (_a = {},
                    _a[Checkbox_st_css_1.classes.focused] = isFocused,
                    _a)), "data-hook": dataHooks_1.CHECKBOX_DATA_HOOKS.IconWrapper }, checked && !error ? (React.createElement(CheckboxChecked_1.default, null)) : indeterminate && !error ? (React.createElement(CheckboxIndeterminate_1.default, null)) : ('')));
        };
        _this._onFocus = function () {
            _this.setState({ focused: true });
        };
        _this._onBlur = function () {
            _this.setState({ focused: false });
        };
        _this._toggleTooltip = function (showTooltip) {
            _this.setState({ isErrorTooltipShown: showTooltip });
        };
        _this._onErrorButtonClick = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            _this._toggleTooltip(!isErrorTooltipShown);
        };
        _this._onClickOutside = function () {
            if (_this._rootRef.current &&
                !_this._rootRef.current.contains(document.activeElement)) {
                _this._toggleTooltip(false);
            }
        };
        _this._getErrorSuffix = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            var errorMessage = _this.props.errorMessage;
            return (React.createElement("div", { className: Checkbox_st_css_1.classes.iconToolTip },
                React.createElement(IconTooltip_1.IconTooltip, { "data-hook": dataHooks_1.CHECKBOX_DATA_HOOKS.ErrorIcon, message: errorMessage, icon: React.createElement(Error_1.default, { className: Checkbox_st_css_1.classes.errorIcon }), tooltipId: _this._errorMessageId, tooltipSkin: TooltipEnums_1.TooltipSkin.Error, showTooltip: isErrorTooltipShown, onClick: _this._onErrorButtonClick, onClickOutside: _this._onClickOutside })));
        };
        _this._errorMessageId = uniqueId('error-message');
        return _this;
    }
    Checkbox.prototype.getDataAttributes = function () {
        var _a;
        var _b = this.props, disabled = _b.disabled, error = _b.error, indeterminate = _b.indeterminate, checked = _b.checked;
        var focused = this.state.focused;
        return _a = {},
            _a[dataHooks_1.CHEKCBOX_DATA_KEYS.Disabled] = disabled,
            _a[dataHooks_1.CHEKCBOX_DATA_KEYS.Error] = error,
            _a[dataHooks_1.CHEKCBOX_DATA_KEYS.Indeterminate] = indeterminate,
            _a[dataHooks_1.CHEKCBOX_DATA_KEYS.Checked] = checked,
            _a[dataHooks_1.CHEKCBOX_DATA_KEYS.Focused] = focused,
            _a;
    };
    Checkbox.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, checked = _b.checked, disabled = _b.disabled, label = _b.label, error = _b.error, errorMessage = _b.errorMessage, indeterminate = _b.indeterminate, onChange = _b.onChange, name = _b.name, suffix = _b.suffix, className = _b.className, withFocusRing = _b.withFocusRing;
        var isMobile = this.context.mobile;
        var focusedBox = !isMobile &&
            withFocusRing &&
            this.state.focused &&
            theme === CheckboxTheme.Box;
        var focusedIcon = !isMobile &&
            withFocusRing &&
            this.state.focused &&
            theme === CheckboxTheme.Default;
        var iconContent = this._renderIcon(focusedIcon);
        var shouldShowErrorIcon = error && errorMessage;
        return (React.createElement("div", __assign({ className: Checkbox_st_css_1.st(Checkbox_st_css_1.classes.root, { box: theme === 'box', checked: checked, disabled: disabled, error: error }, focusedBox ? Checkbox_st_css_1.classes.focused : '', className), "data-hook": this.props['data-hook'], ref: this._rootRef }, this.getDataAttributes()),
            React.createElement(checkbox_1.Checkbox, { className: Checkbox_st_css_1.classes.core, checkedIcon: iconContent, uncheckedIcon: iconContent, indeterminateIcon: iconContent, indeterminate: indeterminate, checked: checked, onChange: onChange, name: name, disabled: disabled, onFocusByKeyboard: this._onFocus, onBlur: this._onBlur, "data-hook": dataHooks_1.CHECKBOX_DATA_HOOKS.CheckboxCore, "aria-invalid": error, "aria-describedby": this._errorMessageId },
                React.createElement("div", { "data-hook": dataHooks_1.CHECKBOX_DATA_HOOKS.LabelWrapper, className: classnames_1.default(Checkbox_st_css_1.classes.label, (_a = {},
                        _a[Checkbox_st_css_1.classes.suffixed] = !!suffix,
                        _a)) }, label),
                suffix && (React.createElement("div", { className: Checkbox_st_css_1.classes.label + " " + Checkbox_st_css_1.classes.suffix }, suffix)),
                shouldShowErrorIcon ? this._getErrorSuffix() : null)));
    };
    Checkbox.displayName = 'Checkbox';
    Checkbox.defaultProps = {
        checked: false,
        disabled: false,
        label: '',
        error: false,
        errorMessage: '',
        indeterminate: false,
        theme: CheckboxTheme.Default,
        'data-hook': dataHooks_1.CHECKBOX_DATA_HOOKS.CheckboxWrapper,
        withFocusRing: false,
    };
    return Checkbox;
}(React.Component));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map